// extracted by mini-css-extract-plugin
export var alternate = "_n-j";
export var black = "_n-6";
export var blue = "_n-f";
export var blueLight = "_n-e";
export var brand = "_n-8";
export var darkMode = "_n-b";
export var error = "_n-a";
export var gray = "_n-5";
export var grayBlue = "_n-d";
export var iconWrapper = "_n-3";
export var inactive = "_n-7";
export var indigo = "_n-g";
export var orange = "_n-i";
export var pink = "_n-h";
export var primary = "_n-0";
export var purple = "_n-9";
export var success = "_n-4";
export var warning = "_n-c";
export var white = "_n-1";
export var whiteSuccess = "_n-2";